import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  Observable, of, Subject } from 'rxjs';
import { AuthService } from './services/auth.service';
import { AppSettings } from './appsettings';
import { NotificationService } from './services/notification.service';

import { environment } from 'src/environments/environment';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { HeaderUserModel } from './pathways-ui/models/header-user.model';
import { NotificationCollection } from './pathways-ui/models/notification-collection.model';
import { ReferenceTableService } from './pathways-ui/services/reference-table.service';
import { LangService } from './pathways-ui/services/lang.service';
import { StudentProfile } from './pathways-ui/models/student-profile.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title = 'pathways-data-works';
    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();
    userAuthenticated: boolean;
    user: HeaderUserModel = null;
    AppSettings = AppSettings;
    notifications$: Observable<NotificationCollection[]> = of([]);
    studentProfile: StudentProfile;
    destroyed = new Subject();

    constructor(
        private _authService: AuthService,
        private translate: TranslateService,
        private referenceTables: ReferenceTableService,
        private lang: LangService,
        private _notificationService: NotificationService,
        private _adapter: DateAdapter<any>,
		@Inject(MAT_DATE_LOCALE) private _locale: string,
    ) {
        // referenceTables.referenceController = "http://localhost:5000" + referenceTables.referenceController
        // bo.backofficeController = "http://localhost:5000" + bo.backofficeController;
    }

    async ngOnInit() {
        this.setLanguageFromHostname();
        this.translate.use(this.lang.currentLang);
        this.isIframe = window !== window.parent && !window.opener;
        // this.checkAccount();
        this._authService.isAuthenticated().then((userAuthenticated) => {
            this.userAuthenticated = userAuthenticated;
            this._authService.checkUserApp();
        });
        this._authService.currentUser$.subscribe(async (u) => {
            if (u) {
                this.user = {
                    firstName: u.profile['given_name'],
                    lastName: u.profile['family_name'],
                    avatar: '',
                };
                await this.referenceTables.setAllReferenceTablesOnAppLoad();
                this.notifications$ = this._notificationService.getNotifications();
            } else {
                this.user = null;
            }
        });
    }

    private setLanguageFromHostname() {
		const hostName = window.location.hostname;

		if (hostName.includes(environment.connex_host_name_fr)) this.setLang("fr");
		if (hostName.includes(environment.connex_host_name_en)) this.setLang("en");
	}

	setLang(lang: string) {
        this.lang.currentLang = lang;
        this._locale = lang;
        this._adapter.setLocale(this._locale);
    }

    markListAsRead($event: number[]) {
        this._notificationService.markListAsRead($event).subscribe(() => {
            this.notifications$ = this._notificationService.getNotifications();
        });
    }
    
    login() {
        this._authService.login();
    }

    logout() {
        this._authService.logout();
    }

    ngOnDestroy(): void {
        this.destroyed.next(true);
        this.destroyed.complete();
    }
}
